<template>
  <div class="inventory-tubes-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'InventoryTubesChart',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            return val.toFixed(0) + ' ft'
          },
          offsetX: 30,
        },
        xaxis: {
          categories: ['2x2 Tubing', '2x3 Tubing', '2x4 Tubing'],
          title: {
            text: 'Linear Feet',
          },
        },
        colors: ['#3c58e7'],
        tooltip: {
          y: {
            formatter: (val) => {
              return val.toFixed(2) + ' linear feet'
            },
          },
        },
      }
    },
    series() {
      const tubes = this.data?.tubes || { '2x2': 0, '2x3': 0, '2x4': 0 }
      return [
        {
          name: 'Linear Feet',
          data: [tubes['2x2'], tubes['2x3'], tubes['2x4']],
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>



